import { useMutation, useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IDefaultCancellationWindow } from '~/Models/DTO/Location.models';

export const useDefaultCancellationWindow = (locationId: string, enabled: boolean = true) => {
  const query = useQuery(
    [REQUEST_ACTIONS.LOCATION_CANCELLATION_WINDOW, locationId],
    async () =>
      requestReactQuery<IDefaultCancellationWindow>({
        url: routeReplacer(EVENT_SERVICE_URLS.LOCATION_CANCELLATION_WINDOW, {
          locationId,
        }),
        config: { method: 'GET' },
      }),
    {
      enabled,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      retry: false,
      refetchInterval: TIME_VALUES.HOUR,
    },
  );

  return {
    ...query,
    // in the scenario where the cancellation window was just turned off, we don't want the old
    // data to be returned (default react query behaviour) because the request results in a 404
    data: query.error ? null : query.data,
  };
};

export const useUpdateDefaultCancellationWindow = () => {
  const query = useMutation(
    async (payload: { locationId: string; defaultCancellationWindow: number }) =>
      requestReactQuery<boolean>({
        url: routeReplacer(EVENT_SERVICE_URLS.LOCATION_CANCELLATION_WINDOW, {
          locationId: payload.locationId,
        }),
        data: { defaultCancellationWindow: payload.defaultCancellationWindow },
        config: { method: 'POST' },
      }),
  );

  return query.mutate;
};
